import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, ContainerCol } from '../componentes_formulario/contenedores';
import ModalResponsive from '../componentes_formulario/modals/modalresponsive';
// import ReactSelect from '../componentes_formulario/selects/react-select';
import {LabelForm, LabelTotales, LabelValorTotales} from '../componentes_formulario/labels';
import AgGridRender from '../grid/ag_grid_render';
import { bindActionCreators } from 'redux';
import { formatearNumeroDecimal } from '../../../funciones_globales/format';
import global_axios  from '../../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../../actions/generales/act_gen01';
import { InputText } from '../componentes_formulario/inputs/inputtext';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { cargarCatalogosGenericoAsyncInvertido,cargarCatalogos_Otros } from '../../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_formulario/selects/react-select-async';
import InputSearch from '../componentes_formulario/inputs/inputsearch';
import ReactSelect from '../componentes_formulario/selects/react-select';

const ContenedorModal = styled.div`
  margin-top: 20px;
  height: 400px;
  width: 770px;
`;
const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;


//props principales : usuario, tipo
class GastoImportacionModal extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            cuenta_importacion:'',
            cuenta_importacion_descripcion:'',
            cuenta_descripcion:'',
            catRubroGastoImportacion:[],
            catRubroGastoImportacion_sel: null,
            catGastoImportacion:null,
            importacion_sel:null,
            tipo_transaccion:'C',
            data_gastos:[],
            gasto_sel:null,
            total_gasto:0,
            bloqueaTotalGasto:false,

            colImportacion:[
                {   header: "Importación",
                    field: "Importacion",
                    width: 100,
                    type: "string"
                },
                {   header: "F.O.B",
                    field: "ValorFOB",
                    width: 100,
                    type: "num_decimal"
                },
                {
                    header: "Porcentaje",
                    field: "Porcentaje",
                    width: 100,
                    type: "num_decimal"
                },
                // {   header: "",
                //     field: "eliminar",
                //     width: 100,
                //     type: "link_elim",
                //     suppressFilter: true,
                //     suppressSorting: true
                // }
            ],
            colGasto:[
                {   header: "Importación",
                    field: "Importacion",
                    width: 100,
                    type: "string"
                },
                {   header: "Cod. Gasto",
                    field: "CodGasto",
                    width: 100,
                    type: "string"
                },
                {
                    header: "Gasto",
                    field: "Gasto",
                    width: 100,
                    type: "string"
                },
                {
                    header: "Valor",
                    field: "Valor",
                    width: 100,
                    type: "num_decimal"
                },
                // {   header: "",
                //     field: "eliminar",
                //     width: 100,
                //     type: "link_elim",
                //     suppressFilter: true,
                //     suppressSorting: true
                // }
            ],
        };
        
        this.gridImportacion = {
            context: {
                componentParent: this
            },      
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
               
			},
        };
        this.gridGasto = {
            context: {
                componentParent: this
            },      
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
               
			},
        };
        this.handleInputChange = this.handleInputChange.bind(this)
        this.onGridImportacionReady= this.onGridImportacionReady.bind(this);
        this.onGridGastoReady= this.onGridGastoReady.bind(this);
        this.immutablePush = this.immutablePush.bind(this);
        this.immutableDelete = this.immutableDelete.bind(this);
        this.insertarImportacion= this.insertarImportacion.bind(this);
        //this.eliminarImportacion=  this.eliminarImportacion.bind(this);
        this.limpiar=this.limpiar.bind(this);
        // this.getConsolidadoImportacion = this.getConsolidadoImportacion.bind(this)
        this.changeImportacion= this.changeImportacion.bind(this);
        this.distribuirGasto = this.distribuirGasto.bind(this);
        this.enviarDataToParent = this.enviarDataToParent.bind(this)
        this.controlConsolidado = this.controlConsolidado.bind(this)
        this.recalcular=this.recalcular.bind(this)
    }
    recalcular()
    {   console.log("DENTROOO PILAS")
        console.log("API" )
        console.log(this.apiGasto)
        console.log(this.props)
        console.log(this.state)
        //Se procede a obtener los totales que fueron distribuidos  en cada gasto, esto con el fin de tener el valor base.
        //Se realiza un calculo para saber si el numero de importaciones del consolidado cambio, esto con el fin de saber si se podra recalcular los valores.
        //El proceso del calculo es el siguiente: se procede a recorrer los gastos de importacion seleccionados para identificar cuantos gastos poseen, luego se lo multiplica por la cantidad de importaciones del consolidado
        //Si la multiplicación da el length de los gastos aplicados esta correcto si da diferente es porque aumento el consolidado de importación.
        //Ejemplo: se tiene 3 importaciones consolidadas y se desea distribuirlas en 3 gastos distintos, entonces el total de gastos distribuidos es 3x3=9, deberian existir 9 gastos distribuidos.
        //El resultado es 9 porque cada importacion poseera los 3 gastos y como son 3 importaciones se tendra un total de 9 registros.

        //Se recorre el arreglo de gastos.
       
        let array_gastos=[];
        for(let i=0; i<this.props.gastos_importacion.length; i++){
            if(i===0){// Se inserta el primer gasto.
                array_gastos.push(this.props.gastos_importacion[i])
            }
            //Se procede a comparar los codigos de gasto para que solo los inserte una vez que son distintos.
            let encontrado=false;
            for(let j =0; j<array_gastos.length;j++){
                if(array_gastos[j].CodGasto===this.props.gastos_importacion[i].CodGasto){
                    encontrado=true;
                }
            }
            if(!encontrado){
                array_gastos.push(this.props.gastos_importacion[i])
            }
        }
        console.log("LOS GASTOS SON ")
        console.log(array_gastos)
        var cantidadDeGastos= array_gastos.length;//posee la cantidad de gastos sobre los que se distribuyo.
        var cantidadDeImportaciones = this.props.data_importaciones.length;
        var cantidadDeGastosDistribuidos= this.props.gastos_importacion.length;
        //Proceso de validacion
        var cantidad_total_distribuido= cantidadDeGastos*cantidadDeImportaciones;
        console.log("CANTIDAD TOTAL DISTRIBUIDA "+ cantidad_total_distribuido)
        console.log("CANTIDAD GASTO DISTRIBUIDO "+ cantidadDeGastosDistribuidos)
        let proceder = true;
        if(cantidad_total_distribuido>cantidadDeGastosDistribuidos || cantidad_total_distribuido<cantidadDeGastosDistribuidos){//Si ambos son iguales no se han incrementado las importaciones, ni los gastos.
            proceder= false;
        }
        if(proceder){
            //Se procede a obtener los totales
            var total=0;//Contendra el total del gasto distribuido->ejemplo si se posee 3 importaciones y un gasto aplicado se tendria el siguiente esquema
            //Impor1 Gasto 03 $3
            //Impor2 Gasto 03 $2
            //Impor3 Gasto 03 $1 
            //Total 6-> la variable contendria 6.
            //La variable se encerara cuando la importación ya corresponde a otra distribucion de gasto.
            var array_totales_distribuido=[];//Contendra los totales obtenidos
            let distribucion_numero= 1;//La variable contiene el numero actual de la distribucion de gastos
            //Ejemplo se posee las importaciones Impo1, Impo2, Impo3 distribuidas con los siguientes gastos: Gasto01, Gasto02, Gasto03.
            //El total de registros serian 9 debido a que por cada gasto habran 3 importaciones.
            //La variable contendra el numero de gastos que intervinieron en la distribucion, para este caso en las interacciones contendra 1, 2, 3.
            for(let p=0; p<this.props.gastos_importacion.length; p++)
            {   
                let intento= p+1;
                let numero_de_importaciones= this.props.data_importaciones.length;
                total = total+parseFloat(this.props.gastos_importacion[p].Valor);
                if((numero_de_importaciones*distribucion_numero) === intento){
                    let objeto={};
                    objeto.CodGasto= this.props.gastos_importacion[p].CodGasto;
                    objeto.Total= total;
                    array_totales_distribuido.push(objeto)
                    distribucion_numero=distribucion_numero+1;
                    total=0;
                }

            }
            console.log("ANTES DEL RECALCULO")
            console.log( this.props.gastos_importacion)
            //Se procede a realizar el recalculo
            //Para cada importacion se recorren todos los gastos de importacion para modificar el valor de aquellos iguales a la importacion.
            let gastos_importacion = this.props.gastos_importacion;
            this.props.data_importaciones.forEach(importacion => {
                let porcentaje=(parseFloat(importacion.ValorFOB)/parseFloat(this.props.total_importacion))*100;
                gastos_importacion.forEach(gasto => {
                    array_totales_distribuido.forEach(totalGasto => {
                         if( (importacion.Importacion === gasto.Importacion) && gasto.CodGasto === totalGasto.CodGasto ){
                            gasto.Valor= parseFloat((parseFloat(totalGasto.Total) * parseFloat(porcentaje))/100).toFixed(2);
                         }
                    });
                });
                
            });
            let total_gasto_final=0;
            gastos_importacion.forEach(gasto => {
                total_gasto_final=total_gasto_final+ parseFloat(gasto.Valor)
            });
            console.log("TOTAL GASTO CARGADO "+ this.props.total_gasto_distribuido)
            console.log("TOTAL GASTO CALCULADO "+ total_gasto_final)
        
            console.log("EL ARRAY ")
            console.log(gastos_importacion)
            let diferenciaDecimales=parseFloat(parseFloat(total_gasto_final  - this.props.total_gasto_distribuido).toFixed(2));
            console.log("DIFERENCIA DECIMALES" + diferenciaDecimales)
            if(diferenciaDecimales>0 || diferenciaDecimales < 0){
                //Se resta al ultimo gasto la diferencia
                gastos_importacion[gastos_importacion.length-1].Valor= parseFloat(parseFloat( gastos_importacion[gastos_importacion.length-1].Valor) - diferenciaDecimales).toFixed(2);
            }
            //Se vuelve a calcular el total
            total_gasto_final=0;
            gastos_importacion.forEach(gasto => {
                total_gasto_final=total_gasto_final+ parseFloat(gasto.Valor)
            });
            this.props.actulizaGridGastoCallBack(gastos_importacion)
            this.props.actualizaTotalGastoDistribuidoCallBack(total_gasto_final)
            this.apiGasto.refreshCells();
            this.setState({data_gastos:gastos_importacion, numero_consolidado:this.props.numero_consolidado})
        }else{
            alert("El recalculo se puede realizar siempre y cuando el numero de importaciones no haya cambiado.")
        }


        
    }
    cargarCatalogos_OtrosParametrosSimplex(tipo){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    distribuirGasto(){
       
        let continuar= true;
        let mensaje_error= "";
        if(this.props.data_importaciones.length===0){//Se valida que tenga importaciones ingresadas.
            continuar= false;
            mensaje_error=mensaje_error +"- Debe ingresar Importaciones o cargar Importaciones consolidadas. \n";
        }
        if(this.props.total_gasto_general===0){//Se valida que el total de gasto_general que es el input de la cabecera contenga un valor, puesto que ese es el valor que no podra superar.
            continuar= false;
            mensaje_error=mensaje_error +"- Debe ingresar un valor para el total general de gastos a distribuir. \n";
        }
        if(this.props.catRubroGastoImportacion_sel=== null || this.state.total_gasto===0){//Se valida que se haya seleccionado un gasto y que se le asigne valor.
            continuar= false;
            mensaje_error=mensaje_error +"- Debe seleccionar un gasto y asignarle un total de gasto para poder distribuir. \n";
        }   

        let total_ingresar= parseFloat(this.props.total_gasto_distribuido) + parseFloat(this.state.total_gasto);
        if(total_ingresar>parseFloat(this.props.total_gasto_general)){//Se valida que el gasto a ingresar no supere el total.
            continuar= false;
            mensaje_error=mensaje_error +"- El valor ingresado supera el total de Gasto General. \n";
        }
        if(continuar){
            var data_gastos=[];
            var total=0;//total con todos los decimales
            var total_dos_decimales=0;//total con cantidades a dos decimales
            //Se valida si el gasto ya fue ingresado.
            if(this.state.data_gastos.length>0){
                //Se recorre el array  de data gastos para saber si existe.
                let encontrado = false;
                for(let j=0; j< this.state.data_gastos.length; j++){
                    let gasto= this.state.data_gastos[j]; 
                    if(gasto.CodGasto === this.props.catRubroGastoImportacion_sel.value)
                    {
                        encontrado=true;
                    }
                }
                if(!encontrado){
                   
                 
                    for(let i=0; i <this.props.data_importaciones.length;i++){
                        let objeto  = {};
                        let valorAux= 0;
                        let importacion = this.props.data_importaciones[i];
                        let porcentaje=(parseFloat(importacion.ValorFOB)/parseFloat(this.props.total_importacion))*100;
                        valorAux=  parseFloat((parseFloat(this.state.total_gasto) * parseFloat(porcentaje))/100);
                        objeto.Importacion = importacion.Importacion;
                        objeto.CodGasto = this.props.catRubroGastoImportacion_sel.value;
                        objeto.Gasto = this.props.catRubroGastoImportacion_sel.label;
                        objeto.Valor = parseFloat((parseFloat(this.state.total_gasto) * parseFloat(porcentaje))/100).toFixed(2);
                        objeto.Porcentaje = porcentaje.toFixed(2);
                        objeto.Cuenta= this.state.cuenta_importacion;
                        objeto.Descripcion = this.state.cuenta_descripcion+ ', IMP: '+importacion.Importacion+ ', GASTO:'+ this.props.catRubroGastoImportacion_sel.label;
                        total= total+ parseFloat(valorAux);
                        total_dos_decimales= total_dos_decimales+ parseFloat(valorAux.toFixed(2));
                        //condicion de resta o suma i+1 = lengh
                        if((i+1)===this.props.data_importaciones.length){
                            let diferenciaDecimales=parseFloat(parseFloat(total_dos_decimales-total).toFixed(2));
                            console.log("VARIABLES PARA CALCULO DE DECIMALES")
                            console.log("VARIABLES TOTAL")
                            console.log(total)
                            console.log("VARIABLE TOTAL DOS DECIMALES")
                            console.log(total_dos_decimales)
                            console.log("DIFERENCIA")
                            console.log(diferenciaDecimales)
                            if(diferenciaDecimales>0 || diferenciaDecimales<0){
                                //Al momento de redondear a dos decimales, el total con todos los decimales es mayor
                                objeto.Valor=parseFloat(parseFloat(objeto.Valor) - diferenciaDecimales).toFixed(2);
                            }
                        }
                        data_gastos.push(objeto)
                    }
                    //Se calcula el total con los valores recalculados
                    total=0;
                    data_gastos.forEach(element => {
                        total=total+parseFloat(element.Valor)
                    });
                    let total_general = this.props.total_gasto_distribuido+total;
                    this.props.actualizaTotalGastoDistribuidoCallBack(total_general)
                  
                    
                    this.setState({bloqueaTotalGasto:true,data_gastos:[...this.state.data_gastos,...data_gastos]},()=>{
                        this.props.actulizaGridGastoCallBack(this.state.data_gastos)
                    })
                   
                }else{
                    alert('El gasto ya fue ingresado')
                }
            }else{
              
                for(let i=0; i <this.props.data_importaciones.length;i++){
                    let objeto  = {};
                    let importacion = this.props.data_importaciones[i];
                    let valorAux= 0;
                    let porcentaje=(parseFloat(importacion.ValorFOB)/parseFloat(this.props.total_importacion))*100;
                    valorAux=  parseFloat((parseFloat(this.state.total_gasto) * parseFloat(porcentaje))/100);
                    objeto.Importacion = importacion.Importacion;
                    objeto.CodGasto = this.props.catRubroGastoImportacion_sel.value;
                    objeto.Gasto = this.props.catRubroGastoImportacion_sel.label;
                    objeto.Valor = parseFloat((parseFloat(this.state.total_gasto) * parseFloat(porcentaje))/100).toFixed(2);
                    objeto.Porcentaje = porcentaje.toFixed(2);
                    objeto.Cuenta= this.state.cuenta_importacion;
                    objeto.Descripcion = this.state.cuenta_descripcion+ ', IMP: '+importacion.Importacion + ', GASTO:'+ this.props.catRubroGastoImportacion_sel.label;
                   
                    total= total+ parseFloat(valorAux);
                    total_dos_decimales= total_dos_decimales+ parseFloat(valorAux.toFixed(2));
                    if((i+1)===this.props.data_importaciones.length){
                        let diferenciaDecimales=parseFloat(parseFloat(total_dos_decimales-total).toFixed(2));
                       
                        if(diferenciaDecimales>0 || diferenciaDecimales<0){
                            //Al momento de redondear a dos decimales, el total con todos los decimales es mayor
                            objeto.Valor=parseFloat(parseFloat(objeto.Valor) - diferenciaDecimales).toFixed(2);
                        }
                    }
                    data_gastos.push(objeto)
                }
                total=0;
                data_gastos.forEach(element => {
                    total=total+parseFloat(element.Valor)
                });
                let total_general = this.props.total_gasto_distribuido+total;
                this.props.actualizaTotalGastoDistribuidoCallBack(total_general)
               
                this.setState({bloqueaTotalGasto:true,data_gastos:[...this.state.data_gastos,...data_gastos]},()=>{
                    this.props.actulizaGridGastoCallBack(this.state.data_gastos)
                })
            }
            
        }else{
            alert(mensaje_error)
        }
        
    
        
    }
    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        console.log("TYPEEEE")
        console.log(target.type)
        if(target.type==='text' && name==='numero_consolidado')
        {   
            this.props.actulizaNumeroConsolidadoCallBack(value)
        }   
        if(target.type==='number' && name==='total_gasto_general')
        {   
            this.props.actualizaTotalGeneralCallBack(value)
        }  
        if(target.type==='radio'){
            this.limpiar('');
            // console.log("ESTOY DENTRO PILAS")
            // if(value==='C'){
            //     console.log("AQUI ESTOY")
            //     this.gridApiColumnaImportacion.setColumnsVisible(['eliminar'], false)
            // }else{
            //     console.log("DE ALGUNA MANERA ENTRE AQUI")
            //     this.gridApiColumnaImportacion.setColumnsVisible(['eliminar'], true)
            // }
        }
        this.setState({
            [name]: value
        });

    }
    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }
    methodFromParent(id, datos_fila) {
        console.log(id)
        console.log(datos_fila)
        let mensaje ="";    
        if(datos_fila.hasOwnProperty('Importacion') && datos_fila.hasOwnProperty("ValorFOB")){
            mensaje = window.confirm('¿Está seguro de eliminar la importacion: ' +datos_fila.Importacion+ '?'); 
            
            if (mensaje){
                this.eliminarImportacion(datos_fila ,id) 
            }
        } 

    }
    eliminarImportacion(importacion,index){
        console.log("EN ELIMINARRR")
        // let total = parseFloat(this.state.total_importacion) - parseFloat(importacion.ValorFOB);  
        // this.setState({ data_importaciones: this.immutableDelete(this.state.data_importaciones, index), total_importacion:total});
        this.props.eliminarImportacionCallback({importacion,index});
    }
    insertarImportacion(importacion){
        // let total = parseFloat(this.state.total_importacion) + parseFloat(importacion.ValorFOB);  
        // this.setState({ data_importaciones: this.immutablePush(this.state.data_importaciones, importacion), total_importacion:total});
        this.props.insertarImportacionCallBack(importacion);
        this.apiImportacion.refreshCells();
    }
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }
    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }
    changeImportacion(value){
        console.log("ESTE ES EL VALOR DEL COMBO")
        console.log(value)
        let continuar =true;
        if(value !== null){
            if(Array.isArray(value))
            {
                if(value.length===0){
                    continuar=false;
                }
            }
            if(continuar){
                    this.setState({importacion_sel: value!==null?value:null})
                    global_axios.get('/importaciones/'+value.value+'/importacionencabezado')
                    .then((response)=>{
                        //Se procede a verificar si la importacion ya fue ingresada.
                        let encontrado = false;
                        for(let i=0; i < this.props.data_importaciones.length; i++){
                            if(this.props.data_importaciones[i].Importacion === response.data.ImportacionResponse.Importacion){
                                encontrado=true;
                            }
                        }
                        console.log(response.data.ImportacionResponse)
                        if(!encontrado){
                            this.insertarImportacion(response.data.ImportacionResponse)
                        }else{
                            alert('La Importación ya fue ingresada')
                        }
                       
                    })
                    .catch((err)=>{
                        alert(err.response?err.response.data.msg:err.message);  
                    });
            
                
            }else{
                this.setState({importacion_sel: null})
            }
            
        }else{
            this.setState({importacion_sel: null})
        }
        
    }
    
    onGridImportacionReady(params) {
		this.apiImportacion = params.api;
		this.gridApiColumnaImportacion = params.columnApi;
    }
     
    onGridGastoReady(params) {
		this.apiGasto = params.api;
		this.gridApiColumnaGasto = params.columnApi;
    }
    limpiar(tipo){
        console.log(tipo)
        if(tipo==='' || tipo ===null){
            this.setState({  
                catGastoImportacion:null,
                importacion_sel:null,
                data_gastos:[],
                total_gasto:0,
                gasto_sel:null,
                bloqueaTotalGasto:false},()=>{
                    this.props.limpiarModalImportacionCallBack(tipo);
                    this.props.actulizaGridGastoCallBack(this.state.data_gastos);
                    this.props.actulizaNumeroConsolidadoCallBack('');
                })
        }
        else{
            this.setState({  
                catGastoImportacion:null,
                importacion_sel:null,
                tipo_transaccion:'C',
                data_gastos:[],
                total_gasto:0,
                gasto_sel:null,
                catRubroGastoImportacion_sel:null,
                bloqueaTotalGasto:false},()=>{
                    this.props.limpiarModalImportacionCallBack(tipo);
                    this.props.actulizaGridGastoCallBack(this.state.data_gastos);
                    this.props.actulizaNumeroConsolidadoCallBack('');
                })
                console.log(this.state.importacion_sel)
        }
       
     
        
    }
    controlConsolidado(){
        //this.gridApiColumnaImportacion.setColumnsVisible(['eliminar'], false);
        this.limpiar('')
    }
    componentDidMount(){     
        Promise.all([
            this.cargarCatalogos_OtrosParametrosSimplex('COM-PARIMPCTAC'),
            cargarCatalogos_Otros('IMP-RUBROGASTO'),
          ])
        .then(([ cuenta_importacion,r_catRubroGastoImportacion ]) => {
            console.log(cuenta_importacion)
           
            this.setState({ 
                catRubroGastoImportacion:r_catRubroGastoImportacion,
                cuenta_importacion:cuenta_importacion[0].cuenta,
                cuenta_importacion_descripcion: cuenta_importacion[0].Nombre+'('+cuenta_importacion[0].cuenta+')',
                cuenta_descripcion : cuenta_importacion[0].Nombre
            });
           
        })
        .catch(error => {
            alert(error);
        });
    }
    
    // getConsolidadoImportacion(){
    //     if((this.state.numero_consolidado!=='' && this.state.numero_consolidado!==null)&& this.state.tipo_transaccion==='C'){
    //         global_axios.get('/importaciones/'+this.state.numero_consolidado+'/importacionconsolidada')
    //                 .then((response)=>{
    //                    if(response.data.ConsolidadoImportacionResponse!==null&& response.data.ConsolidadoImportacionResponse.length>0){
    //                     let consolidados= response.data.ConsolidadoImportacionResponse;
    //                     let data_importaciones=[];
    //                     let total_importacion=0;
    //                     for(let i=0; i< consolidados.length;i++)
    //                     {
    //                         let objeto= {};
    //                         objeto.Importacion= consolidados[i].Importacion;
    //                         objeto.ValorFOB = consolidados[i].import.ValorFOB;
    //                         data_importaciones.push(objeto)
    //                         total_importacion=total_importacion+parseFloat(consolidados[i].import.ValorFOB)
    //                     }

    //                    this.setState({data_importaciones,total_importacion})  
    //                    }else{
    //                        alert('No se encontraron registros para el numero de Consolidado Importación.')
    //                    }
    //                 })
    //                 .catch((err)=>{
    //                     console.log(err)
    //                     alert(err.response?err.response.data?err.response.data.msg:err.message:err.message);  
    //                 });
    //     }else{
    //         alert('Ingrese un numero consolidado de importación para continuar...')
    //     }
    // }
    enviarDataToParent(){//CREO QUE YA NO SERA NECESARIO PUESTO QUE TODA LA DATA ESTARA REFLEJADA
        try{
            if(parseFloat(this.props.total_gasto_distribuido).toFixed(2) === parseFloat(this.props.total_gasto_general).toFixed(2)){
                if(this.props.total_gasto_distribuido>0 && this.props.total_gasto_general>0){
                   
                    if(this.props.operacion!=='G')
                    {   console.log(this.props.gastos_importacion)
                        this.props.gastos_importacion.forEach(gasto => {
                            gasto.Cuenta= this.state.cuenta_importacion;
                            gasto.Descripcion= this.state.cuenta_descripcion+ ', IMP: '+gasto.Importacion+ ', GASTO:'+ gasto.Gasto+ ' ('+gasto.CodGasto+' )';
                        });
                    }
                    this.props.parentCallback({ConsolidadoImportacionId:this.state.numero_consolidado});
                    this.props.close();
                }else{
                    alert('El total general y el total gasto distribuido no pueden ser 0')
                }
            }else{
                alert('Los totales de Gasto General y el Total de Gasto Distribuido deben ser iguales...')
            }
        }catch(error) {
            alert(error)    
        }
    }
    render(){
        return(
            <div>
                <ModalResponsive open={this.props.visible} onClose={this.props.onClose}>
        
                    <ContenedorModal>
                        <Row >
                            <ContainerCol className='col-sm-1'>
                                <LabelForm>Transacción </LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-3'>					
                                <LabelForm className='radio-inline'>
                                    <input type='radio' name='tipo_transaccion' value='C' checked={this.state.tipo_transaccion==='C'} onChange={this.handleInputChange} />
                                    Consolidado
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type='radio' name='tipo_transaccion' value='I' checked={this.state.tipo_transaccion==='I'} onChange={this.handleInputChange} />
                                    Individual
                                </LabelForm>   
                            </ContainerCol>
                            <ContainerCol  className='col-sm-4'>
                                <LabelForm>Cuenta:</LabelForm>
                                <LabelForm>{this.state.cuenta_importacion_descripcion}</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-3'>
                                <div className='input-group'>
                                    <span className='input-group-btn'>
                                        
                                            
                                            <ButtonUnion type='button' className='btn btn-primary btn-sm' disabled={this.apiGasto===undefined || this.props.operacion==='G'} onClick={this.recalcular}><i className='fa fa-calculator'></i>Recalcular</ButtonUnion>   
                                            
                                        
                                        <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.enviarDataToParent}><i className='fa fa-check'></i>Aceptar</ButtonUnion>   
                                        <ButtonUnion type='button' className='btn btn-info btn-sm' onClick={()=>{this.limpiar('S')}}><i className='fa fa-trash'></i>Limpiar</ButtonUnion> 
                                                       
                                    </span>
                                </div>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-4'>
                                <LabelForm>Total Gasto General:</LabelForm>
                                <InputText name='total_gasto_general' disabled={this.state.bloqueaTotalGasto} value={this.props.total_gasto_general} type="number" className='form-control input-sm' onChange={this.handleInputChange}/>
                            </ContainerCol> 
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <h4>{this.props.title}</h4>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <div className='col-sm-12'>
                                <Tabs>
                                <TabList>
                                    <Tab>Importación</Tab>
                                    <Tab>Gasto</Tab>
                                </TabList>
                                <TabPanel>
                                    <Row>
                                        {this.state.tipo_transaccion==='C'?
                                            <ContainerCol className='col-sm-4'>
                                                <LabelForm>Numero de Consolidado:</LabelForm>
                                                <InputSearch tipoInput='text' nombre='numero_consolidado' placeholder='Numero consolidado' valor={this.props.numero_consolidado} func_CambiarValor={this.handleInputChange}
                                                func_BuscarValor={this.props.cargarImportacionesCallBack} func_OnFocus={()=>{this.controlConsolidado()}}/>
                                            </ContainerCol> :
                                            <ContainerCol className='col-sm-6'>
                                                <LabelForm>Importación:</LabelForm>
                                                <ReactSelectAsync value={this.state.importacion_sel}  func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.changeImportacion(value)}}/>
                                            </ContainerCol> 
                                        }
                                    </Row>
                                    <Row>
                                        <div className='col-md-12'>   
                                            <AgGridRender altura='200px' data={this.props.data_importaciones} columnas={this.state.colImportacion} 
                                            gridOptions={this.gridImportacion} onGridReady={this.onGridImportacionReady}/>  
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className='col-sm-6'>
                                            <LabelTotales>Total Importacion: </LabelTotales>
                                            <LabelValorTotales>{formatearNumeroDecimal(this.props.total_importacion)}</LabelValorTotales>
                                        </div>
                                    </Row>
                                </TabPanel>
                                <TabPanel>
                                    <Row>
                                        <ContainerCol className='col-sm-4'>
                                                <LabelForm>Gasto Importac:</LabelForm>
                                               
                                                <div>
                                                    <ReactSelect options={ this.state.catRubroGastoImportacion } disabled = {this.state.deshabilitaGasto} value={this.props.catRubroGastoImportacion_sel} 
                                                    func_onChange={(value)=>{this.props.actualizacatRubroGastoImportacion_selCallBack(value)}}/>
                                                        
                                                </div>                                    
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-2'>
                                            <LabelForm>Total Gasto:</LabelForm>
                                            <InputText name='total_gasto'  value={this.state.total_gasto} type="number" className='form-control input-sm' onChange={this.handleInputChange}/>
                                        </ContainerCol> 
                                        <ContainerCol className='col-sm-2' margen_arriba='20' margen_abajo='10'>
                                            <div className='input-group'>
                                                <span className='input-group-btn'>
                                                    <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.distribuirGasto}><i className='fa fa-plus'></i>Distribuir Gasto</ButtonUnion>                
                                                </span>
                                            </div>
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <div className='col-md-12'>   
                                            <AgGridRender altura='200px' data={this.props.gastos_importacion} columnas={this.state.colGasto} 
                                            gridOptions={this.gridGasto} onGridReady={this.onGridGastoReady}/>  
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className='col-sm-6'>
                                            <LabelTotales>Total Gasto Distribuido: </LabelTotales>
                                            <LabelValorTotales>{formatearNumeroDecimal(this.props.total_gasto_distribuido)}</LabelValorTotales>
                                        </div>
                                    </Row>
                                </TabPanel>
                                </Tabs>
                            </div>
                        </Row>            
                    </ContenedorModal>
                </ModalResponsive>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
    };
});
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cambiar_VisualizacionLoading}, dispatch)
    });
  
export default connect (mapStateToProps,mapDispatchToProps)(GastoImportacionModal);